import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

import Label from '../Label'
import Value from '../Value'

class TextareaField extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editing: false,
      value: null,
    }

    this.onClick = this.onClick.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
  }

  UNSAFE_componentWillMount() {
    const { value } = this.props
    this.setState({ value })
  }

  UNSAFE_componentWillReceiveProps({ value }) {
    if (value !== this.state.value) {
      this.setState({ value })
    }
  }

  onClick() {
    if (!this.props.editable) {
      return
    }

    this.setState({ editing: true })
  }

  onChange(event) {
    const { value } = event.target
    this.setState({ value: value || null })
  }

  onBlur() {
    let newValue = this.state.value
    const prevValue = this.props.value

    if (!newValue && !this.props.nullable) {
      newValue = prevValue
      this.setState({ value: newValue })
    }

    this.setState({ editing: false }, () => {
      if (newValue !== prevValue) {
        this.props.onChange(newValue)
      }
    })
  }

  onKeyPress({ key }) {
    if (key === 'Enter') {
      this.onBlur()
    }
  }

  render() {
    const { label, editable, keepEditorOpen, className, placeholderText } =
      this.props

    const { editing, value } = this.state

    const classNames = [
      editable ? 'editable' : null,
      !value ? 'invalid' : null,
      className,
    ].join(' ')

    const editProps = {
      className: `input ${className}`,
      autoFocus: !keepEditorOpen,
      value: value || '',
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      onBlur: this.onBlur,
      placeholder: placeholderText,
    }

    const valueProps = {
      className: classNames,
      value: value || 'Unknown',
      onClick: this.onClick,
    }

    const showEditor = editing || keepEditorOpen

    return (
      <div className="field textarea">
        <Label text={label} />
        {(showEditor && <textarea {...editProps} />) || (
          <Value {...valueProps} />
        )}
      </div>
    )
  }
}

TextareaField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  editable: PropTypes.bool,
  nullable: PropTypes.bool,
}

export default TextareaField
